import { useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import ProductCards from './components/ProductCards';
import TechnicalSection from './components/TechnicalSection';
import FAQ from './components/FAQ';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';

export default function Home() {
  return (
    <div className="bg-black min-h-screen">
      <Header />
      <Hero />
      <ProductCards />
      <TechnicalSection />
      <FAQ />
      <Footer />
      <WhatsAppButton />
    </div>
  );
}